/** https://www.twilio.com/docs/voice/sdks/javascript/twiliodevice#devicestate **/
import { Device } from '@twilio/voice-sdk';
export const TWILIO_DEVICE_UNREGISTERED = Device.State.Unregistered;
export const TWILIO_DEVICE_REGISTERING = Device.State.Registering;
export const TWILIO_DEVICE_REGISTERED = Device.State.Registered;
export const TWILIO_DEVICE_DESTROYED = Device.State.Destroyed;